define(["require", "exports"], function (require, exports) {
    /*---------------------------------------------------------------------------------------------
     *  Copyright (c) Microsoft Corporation. All rights reserved.
     *  Licensed under the MIT License. See License.txt in the project root for license information.
     *--------------------------------------------------------------------------------------------*/
    'use strict';
});
//# sourceMappingURL=jsonSchema.js.map


// WEBPACK FOOTER //
// ./out/vs/base/common/jsonSchema.js